import request from '@/utils/request'

/**
 * 查询店铺积分信息
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopIntegral(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.queryShopIntegral',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询店铺积分明细
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopIntegralDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.queryShopIntegralDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询积分提现申请列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listIntegralWithdrawal(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.listIntegralWithdrawal',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 申请积分提现
 * @param {Object} data 申请数据
 * @returns {Promise} Promise对象
 */
export function applyIntegralWithdrawal(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.applyIntegralWithdrawal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除积分提现申请
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteIntegralWithdrawal(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.deleteIntegralWithdrawal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}